"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Carrier Profile Service Public
 * The Carrier Profile Public Service (CPPS) API is a public service used to manage all data related to core Carrier company information (such as company name, address, contacts, billing information, etc).  ---  ## **!!! Important Notes !!!**  If you are developing a service which will consume data from the Carrier Profile Public Service you need to take note of the following restriction:  Currently, carriers and associated sub-objects i.e. contacts, documents, and addresses can be created both in CPS and in Salesforce. To avoid multiple master writes, we introduced the concept of data ownership, represented by the field `data_owner` on `Carrier` objects. This can have the values of `CPS` or `SALESFORCE`. All sub-objects of a carrier will have the same implicit data owner as their associated carrier. It is not possible to perform write operations via the API on a carrier not owned by CPS and the API will return a 409 `DATA_OWNER_CONFLICT` error.  ---  ## Authorization  Requests to the CPPS are expected to contain a valid Auth0-issued JWT token encoded as a [Bearer Token](https://www.rfc-editor.org/rfc/rfc6750#section-2.1) in the `Authorization` header.  In addition to the standard claims required with a JWT (`sub`, `iss`, `aud`, etc.) the following claims are required within this token:  `https://sennder.com/user_id`  > Must provide a UUID identifying the user making the request.  `https://sennder.com/tenant`  > The SaaS tenant the user is operating within.  ---  ## Permissions  These are of the form `<resource>:<action>`.  Where `<resource>` and `<action>` are each a series of dash-separated words. Words may contain alpha-numeric characters as well as dashes (ie. a-z/0-9/-).  For example to give permission to read a carrier the required permission is of the form `carriers:read`.  The following permissions are defined:  |PERMISSION|DESCRIPTION| |-|-| |`view_carrier`|Can read the carrier\'s core information| |`update_carrier`|Can update the carrier\'s core information| |`view_contact_list`|Can list contacts associated with the carrier| |`create_contact`|Can create contacts associated with the carrier| |`view_contact`|Can read contacts associated with the carrier| |`update_contact`|Can update contacts associated with the carrier| |`delete_contact`|Can delete contacts associated with the carrier| |`view_document_list`|Can list documents associated with the carrier| |`upload_document`|Can upload documents associated with the carrier| |`view_document`|Can read documents (data object only) associated with the carrier| |`download_document`|Can download documents associated with the carrier| |`update_document`|Can update document meta data associated with the carrier| |`delete_document`|Can delete documents associated with the carrier|  **Individual end-points define which permissions are required**  ---  ## Error Codes  ### 4xx Errors  These indicate an issue with the request originating in some way from the client. In this case, the result will contain an ErrorResponse object containing an error code.  #### Common Error Codes  The following may be returned by any endpoint:  |CODE|DESCRIPTION| |-|-| |`INVALID_HEADERS`|A required header is either missing or invalid.| |`UNAUTHORIZED`|User lacks valid authentication credentials for the requested resource.| |`RESOURCE_FORBIDDEN`|User does not have the required permissions to perform the requested operation.| |`VALIDATION_ERROR`|Request schema validation failed.|  #### Custom Error Codes  Additional error codes may be returned for a given endpoint. **See the associated end-point description for further details**.  ### 5xx Errors  Indicate a server-side issue and have no guaranteed returned type. These are purposefully not described in detail to the client for security reasons.
 *
 * The version of the OpenAPI document: 1.52.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthApi = exports.HealthApiFactory = exports.HealthApiFp = exports.HealthApiAxiosParamCreator = exports.DocumentsApi = exports.DocumentsApiFactory = exports.DocumentsApiFp = exports.DocumentsApiAxiosParamCreator = exports.ContactsApi = exports.ContactsApiFactory = exports.ContactsApiFp = exports.ContactsApiAxiosParamCreator = exports.CarrierApi = exports.CarrierApiFactory = exports.CarrierApiFp = exports.CarrierApiAxiosParamCreator = exports.VATCountryCode = exports.TAPACertificationState = exports.Salutation = exports.HealthStatus = exports.HACCPCertificationState = exports.DocumentVettingStatus = exports.DocumentType = exports.DiscountPercent = exports.CountryCode = exports.ContactRole = exports.CommunicationLanguage = exports.CarrierVettingStatus = exports.CarrierType = exports.CarrierCooperationType = exports.CPSErrorCodes = exports.CO3IntegrationState = exports.ADRCertificationState = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ADRCertificationState = {
    Indicated: 'INDICATED',
    Compliant: 'COMPLIANT',
    NotCompliant: 'NOT_COMPLIANT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CO3IntegrationState = {
    Awaiting: 'AWAITING',
    OngoingStandard: 'ONGOING_STANDARD',
    OngoingComplex: 'ONGOING_COMPLEX',
    Paused: 'PAUSED',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CPSErrorCodes = {
    InvalidHeaders: 'INVALID_HEADERS',
    Unauthorized: 'UNAUTHORIZED',
    ResourceForbidden: 'RESOURCE_FORBIDDEN',
    ValidationError: 'VALIDATION_ERROR',
    ResourceNotFound: 'RESOURCE_NOT_FOUND',
    SfValidationError: 'SF_VALIDATION_ERROR',
    UpstreamServiceError: 'UPSTREAM_SERVICE_ERROR',
    FileTooLarge: 'FILE_TOO_LARGE',
    UnsupportedFiletype: 'UNSUPPORTED_FILETYPE',
    DuplicateVatConflict: 'DUPLICATE_VAT_CONFLICT',
    InvalidCarrierId: 'INVALID_CARRIER_ID',
    DuplicateEmailConflict: 'DUPLICATE_EMAIL_CONFLICT',
    InvalidContactEmail: 'INVALID_CONTACT_EMAIL',
    InternalServerError: 'INTERNAL_SERVER_ERROR',
    CarrierNotFound: 'CARRIER_NOT_FOUND',
    SecondaryAccountModificationException: 'SECONDARY_ACCOUNT_MODIFICATION_EXCEPTION'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierCooperationType = {
    Spot: 'SPOT',
    Chartering: 'CHARTERING',
    LongTermAllocation: 'LONG_TERM_ALLOCATION'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierType = {
    Carrier: 'CARRIER',
    CharteringOffice: 'CHARTERING_OFFICE',
    FreightForwarder: 'FREIGHT_FORWARDER',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierVettingStatus = {
    Unvetted: 'UNVETTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Rejected: 'REJECTED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CommunicationLanguage = {
    Bg: 'bg',
    Hr: 'hr',
    Cs: 'cs',
    Nl: 'nl',
    En: 'en',
    Et: 'et',
    Fr: 'fr',
    De: 'de',
    Hu: 'hu',
    It: 'it',
    Lv: 'lv',
    Lt: 'lt',
    Xx: 'xx',
    Pl: 'pl',
    Pt: 'pt',
    Ro: 'ro',
    Ru: 'ru',
    Sk: 'sk',
    Sl: 'sl',
    Es: 'es',
    Sv: 'sv'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ContactRole = {
    CarrierManager: 'CARRIER_MANAGER',
    CeoOwner: 'CEO_OWNER',
    CharteringCarrierManager: 'CHARTERING_CARRIER_MANAGER',
    CharteringTeamLead: 'CHARTERING_TEAM_LEAD',
    FinanceAdministration: 'FINANCE_ADMINISTRATION',
    HeadOfLogistics: 'HEAD_OF_LOGISTICS',
    HeadOfPurchasingProcurement: 'HEAD_OF_PURCHASING_PROCUREMENT',
    HeadOfTransport: 'HEAD_OF_TRANSPORT',
    LogisticsManager: 'LOGISTICS_MANAGER',
    OpsAdministration: 'OPS_ADMINISTRATION',
    OpsManager24H: 'OPS_MANAGER_24H',
    OpsManagerDaily: 'OPS_MANAGER_DAILY',
    OpsManagerNightWeekend: 'OPS_MANAGER_NIGHT_WEEKEND',
    ProjectManager: 'PROJECT_MANAGER',
    PurchasingProcurementManager: 'PURCHASING_PROCUREMENT_MANAGER',
    SalesManager: 'SALES_MANAGER',
    SupplyChainManager: 'SUPPLY_CHAIN_MANAGER',
    TransportManager: 'TRANSPORT_MANAGER',
    Unknown: 'UNKNOWN'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CountryCode = {
    Af: 'AF',
    Ax: 'AX',
    Al: 'AL',
    Dz: 'DZ',
    Ad: 'AD',
    Ao: 'AO',
    Ai: 'AI',
    Aq: 'AQ',
    Ag: 'AG',
    Ar: 'AR',
    Am: 'AM',
    Aw: 'AW',
    Au: 'AU',
    At: 'AT',
    Az: 'AZ',
    Bs: 'BS',
    Bh: 'BH',
    Bd: 'BD',
    Bb: 'BB',
    By: 'BY',
    Be: 'BE',
    Bz: 'BZ',
    Bj: 'BJ',
    Bm: 'BM',
    Bt: 'BT',
    Bo: 'BO',
    Bq: 'BQ',
    Ba: 'BA',
    Bw: 'BW',
    Bv: 'BV',
    Br: 'BR',
    Io: 'IO',
    Bn: 'BN',
    Bg: 'BG',
    Bf: 'BF',
    Bi: 'BI',
    Cv: 'CV',
    Kh: 'KH',
    Cm: 'CM',
    Ca: 'CA',
    Ky: 'KY',
    Cf: 'CF',
    Td: 'TD',
    Cl: 'CL',
    Cn: 'CN',
    Cx: 'CX',
    Cc: 'CC',
    Co: 'CO',
    Km: 'KM',
    Cd: 'CD',
    Cg: 'CG',
    Ck: 'CK',
    Cr: 'CR',
    Hr: 'HR',
    Cu: 'CU',
    Cw: 'CW',
    Cy: 'CY',
    Cz: 'CZ',
    Dk: 'DK',
    Dj: 'DJ',
    Dm: 'DM',
    Do: 'DO',
    Tl: 'TL',
    Ec: 'EC',
    Eg: 'EG',
    Sv: 'SV',
    Gq: 'GQ',
    Er: 'ER',
    Ee: 'EE',
    Sz: 'SZ',
    Et: 'ET',
    Fk: 'FK',
    Fo: 'FO',
    Fj: 'FJ',
    Fi: 'FI',
    Fr: 'FR',
    Gf: 'GF',
    Pf: 'PF',
    Tf: 'TF',
    Ga: 'GA',
    Gm: 'GM',
    Ge: 'GE',
    De: 'DE',
    Gh: 'GH',
    Gi: 'GI',
    Gr: 'GR',
    Gl: 'GL',
    Gd: 'GD',
    Gp: 'GP',
    Gt: 'GT',
    Gg: 'GG',
    Gn: 'GN',
    Gw: 'GW',
    Gy: 'GY',
    Ht: 'HT',
    Hm: 'HM',
    Hn: 'HN',
    Hu: 'HU',
    Is: 'IS',
    In: 'IN',
    Id: 'ID',
    Ir: 'IR',
    Iq: 'IQ',
    Ie: 'IE',
    Im: 'IM',
    Il: 'IL',
    It: 'IT',
    Ci: 'CI',
    Jm: 'JM',
    Jp: 'JP',
    Je: 'JE',
    Jo: 'JO',
    Kz: 'KZ',
    Ke: 'KE',
    Ki: 'KI',
    Kw: 'KW',
    Kg: 'KG',
    La: 'LA',
    Lv: 'LV',
    Lb: 'LB',
    Ls: 'LS',
    Lr: 'LR',
    Ly: 'LY',
    Li: 'LI',
    Lt: 'LT',
    Lu: 'LU',
    Mo: 'MO',
    Mk: 'MK',
    Mg: 'MG',
    Mw: 'MW',
    My: 'MY',
    Mv: 'MV',
    Ml: 'ML',
    Mt: 'MT',
    Mq: 'MQ',
    Mr: 'MR',
    Mu: 'MU',
    Yt: 'YT',
    Mx: 'MX',
    Md: 'MD',
    Mc: 'MC',
    Mn: 'MN',
    Me: 'ME',
    Ms: 'MS',
    Ma: 'MA',
    Mz: 'MZ',
    Mm: 'MM',
    Na: 'NA',
    Nr: 'NR',
    Np: 'NP',
    Nl: 'NL',
    Nc: 'NC',
    Nz: 'NZ',
    Ni: 'NI',
    Ne: 'NE',
    Ng: 'NG',
    Nu: 'NU',
    Nf: 'NF',
    Kp: 'KP',
    No: 'NO',
    Om: 'OM',
    Pk: 'PK',
    Ps: 'PS',
    Pa: 'PA',
    Pg: 'PG',
    Py: 'PY',
    Pe: 'PE',
    Ph: 'PH',
    Pn: 'PN',
    Pl: 'PL',
    Pt: 'PT',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Ru: 'RU',
    Rw: 'RW',
    Bl: 'BL',
    Sh: 'SH',
    Kn: 'KN',
    Lc: 'LC',
    Mf: 'MF',
    Pm: 'PM',
    Vc: 'VC',
    Ws: 'WS',
    Sm: 'SM',
    St: 'ST',
    Sa: 'SA',
    Sn: 'SN',
    Rs: 'RS',
    Sc: 'SC',
    Sl: 'SL',
    Sg: 'SG',
    Sx: 'SX',
    Sk: 'SK',
    Si: 'SI',
    Sb: 'SB',
    So: 'SO',
    Za: 'ZA',
    Gs: 'GS',
    Kr: 'KR',
    Ss: 'SS',
    Es: 'ES',
    Lk: 'LK',
    Sd: 'SD',
    Sr: 'SR',
    Sj: 'SJ',
    Se: 'SE',
    Ch: 'CH',
    Sy: 'SY',
    Tw: 'TW',
    Tj: 'TJ',
    Tz: 'TZ',
    Th: 'TH',
    Tg: 'TG',
    Tk: 'TK',
    To: 'TO',
    Tt: 'TT',
    Tn: 'TN',
    Tr: 'TR',
    Tm: 'TM',
    Tc: 'TC',
    Tv: 'TV',
    Ug: 'UG',
    Ua: 'UA',
    Ae: 'AE',
    Gb: 'GB',
    Us: 'US',
    Uy: 'UY',
    Uz: 'UZ',
    Vu: 'VU',
    Va: 'VA',
    Ve: 'VE',
    Vn: 'VN',
    Vg: 'VG',
    Wf: 'WF',
    Eh: 'EH',
    Ye: 'YE',
    Zm: 'ZM',
    Zw: 'ZW'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DiscountPercent = {
    NUMBER_0_DOT_0: 0.0,
    NUMBER_1_DOT_0: 1.0,
    NUMBER_1_DOT_5: 1.5,
    NUMBER_2_DOT_0: 2.0,
    NUMBER_2_DOT_5: 2.5,
    NUMBER_3_DOT_0: 3.0,
    NUMBER_4_DOT_0: 4.0,
    NUMBER_5_DOT_0: 5.0
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DocumentType = {
    Adr: 'ADR',
    BankCertificate: 'BANK_CERTIFICATE',
    BrcSAndD: 'BRC_S_AND_D',
    BlankInvoice: 'BLANK_INVOICE',
    ChamberOfCommerce: 'CHAMBER_OF_COMMERCE',
    Durc: 'DURC',
    Duvri: 'DUVRI',
    Fssc22000: 'FSSC22000',
    IfsLogistic: 'IFS_LOGISTIC',
    Insurance: 'INSURANCE',
    Iso9001: 'ISO9001',
    Iso14001: 'ISO14001',
    Iso22000: 'ISO22000',
    LicenseEu: 'LICENSE_EU',
    LicenseDomestic: 'LICENSE_DOMESTIC',
    LegalRepresentativeId: 'LEGAL_REPRESENTATIVE_ID',
    Letterhead: 'LETTERHEAD',
    ManualeDiAutocontrollo: 'MANUALE_DI_AUTOCONTROLLO',
    SelfBillingInvoice: 'SELF_BILLING_INVOICE',
    SelfDeclarationAntimafia: 'SELF_DECLARATION_ANTIMAFIA',
    SelfDeclarationHaccp: 'SELF_DECLARATION_HACCP',
    SelfDeclarationPendingLoads: 'SELF_DECLARATION_PENDING_LOADS',
    SelfDeclarationBankruptcy: 'SELF_DECLARATION_BANKRUPTCY',
    SelfDeclarationAtp: 'SELF_DECLARATION_ATP',
    SocialSecurityPaymentConfirmation: 'SOCIAL_SECURITY_PAYMENT_CONFIRMATION',
    TiaBadge: 'TIA_BADGE',
    VisuraCamerale: 'VISURA_CAMERALE',
    Other: 'OTHER',
    Contract: 'CONTRACT',
    ContractPosteNetwork: 'CONTRACT_POSTE_NETWORK',
    ContractThirdPartiesNetwork: 'CONTRACT_THIRD_PARTIES_NETWORK',
    ContractAllNetworks: 'CONTRACT_ALL_NETWORKS',
    SelfDeclaration: 'SELF_DECLARATION',
    EmployerId: 'EMPLOYER_ID'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DocumentVettingStatus = {
    Unvetted: 'UNVETTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Rejected: 'REJECTED',
    Expired: 'EXPIRED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.HACCPCertificationState = {
    Indicated: 'INDICATED',
    Compliant: 'COMPLIANT',
    CompliantNoFrigo: 'COMPLIANT_NO_FRIGO',
    NotCompliant: 'NOT_COMPLIANT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.HealthStatus = {
    Ok: 'OK'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Salutation = {
    Mr: 'Mr.',
    Ms: 'Ms.',
    DrM: 'Dr. (m)',
    DrF: 'Dr. (f)',
    ProfM: 'Prof. (m)',
    ProfF: 'Prof. (f)'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TAPACertificationState = {
    Indicated: 'INDICATED',
    Compliant: 'COMPLIANT',
    NotCompliant: 'NOT_COMPLIANT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.VATCountryCode = {
    Al: 'AL',
    Ad: 'AD',
    Am: 'AM',
    At: 'AT',
    Az: 'AZ',
    By: 'BY',
    Be: 'BE',
    Ba: 'BA',
    Bg: 'BG',
    Cn: 'CN',
    Hr: 'HR',
    Cy: 'CY',
    Cz: 'CZ',
    Dk: 'DK',
    Ee: 'EE',
    Fi: 'FI',
    Fr: 'FR',
    Ge: 'GE',
    De: 'DE',
    Gr: 'GR',
    El: 'EL',
    Hu: 'HU',
    Is: 'IS',
    Ir: 'IR',
    Ie: 'IE',
    Il: 'IL',
    It: 'IT',
    Kz: 'KZ',
    Lv: 'LV',
    Lt: 'LT',
    Lu: 'LU',
    Mk: 'MK',
    Mt: 'MT',
    Md: 'MD',
    Me: 'ME',
    Ma: 'MA',
    Nl: 'NL',
    No: 'NO',
    Pk: 'PK',
    Pl: 'PL',
    Pt: 'PT',
    Ro: 'RO',
    Ru: 'RU',
    Sm: 'SM',
    Rs: 'RS',
    Sk: 'SK',
    Si: 'SI',
    Es: 'ES',
    Se: 'SE',
    Ch: 'CH',
    Tj: 'TJ',
    Tr: 'TR',
    Tm: 'TM',
    Ua: 'UA',
    Ae: 'AE',
    Gb: 'GB',
    Us: 'US',
    Uz: 'UZ'
};
/**
 * CarrierApi - axios parameter creator
 * @export
 */
var CarrierApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * # Translate Mothership carrier ID to CPS ID  Returns only CPS/SF/MS ID of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Mothership Id To Cps Id
         * @param {number} mothershipId Mothership ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet: function (mothershipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'mothershipId' is not null or undefined
                            (0, common_1.assertParamExists)('mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet', 'mothershipId', mothershipId);
                            localVarPath = "/v1/carriers/id/from-mothership/{mothership_id}"
                                .replace("{".concat("mothership_id", "}"), encodeURIComponent(String(mothershipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Read Carrier  Returns core information associated with the Carrier.  ---  ## Permissions  `view_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/read_carrier_v1_carriers__carrier_id__get\">here</a> may be returned.
         * @summary Read Carrier
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCarrierV1CarriersCarrierIdGet: function (carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('readCarrierV1CarriersCarrierIdGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Translate Salesforce carrier ID to CPS ID  Returns only CPS/MS/SF IDs of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Salesforce Id To Cps Id
         * @param {string} salesforceId Salesforce ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet: function (salesforceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'salesforceId' is not null or undefined
                            (0, common_1.assertParamExists)('salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet', 'salesforceId', salesforceId);
                            localVarPath = "/v1/carriers/id/from-salesforce/{salesforce_id}"
                                .replace("{".concat("salesforce_id", "}"), encodeURIComponent(String(salesforceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Update Carrier  Updates core information associated with the Carrier.  ---  ## Permissions  `update_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/update_carrier_v1_carriers__carrier_id__patch\">here</a> may be returned.
         * @summary Update Carrier
         * @param {string} carrierId Carrier ID
         * @param {CarrierUpdate} carrierUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierV1CarriersCarrierIdPatch: function (carrierId, carrierUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('updateCarrierV1CarriersCarrierIdPatch', 'carrierId', carrierId);
                            // verify required parameter 'carrierUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateCarrierV1CarriersCarrierIdPatch', 'carrierUpdate', carrierUpdate);
                            localVarPath = "/v1/carriers/{carrier_id}"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierApiAxiosParamCreator = CarrierApiAxiosParamCreator;
/**
 * CarrierApi - functional programming interface
 * @export
 */
var CarrierApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierApiAxiosParamCreator)(configuration);
    return {
        /**
         * # Translate Mothership carrier ID to CPS ID  Returns only CPS/SF/MS ID of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Mothership Id To Cps Id
         * @param {number} mothershipId Mothership ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet: function (mothershipId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet(mothershipId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierApi.mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Read Carrier  Returns core information associated with the Carrier.  ---  ## Permissions  `view_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/read_carrier_v1_carriers__carrier_id__get\">here</a> may be returned.
         * @summary Read Carrier
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCarrierV1CarriersCarrierIdGet: function (carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readCarrierV1CarriersCarrierIdGet(carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierApi.readCarrierV1CarriersCarrierIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Translate Salesforce carrier ID to CPS ID  Returns only CPS/MS/SF IDs of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Salesforce Id To Cps Id
         * @param {string} salesforceId Salesforce ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet: function (salesforceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet(salesforceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierApi.salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Update Carrier  Updates core information associated with the Carrier.  ---  ## Permissions  `update_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/update_carrier_v1_carriers__carrier_id__patch\">here</a> may be returned.
         * @summary Update Carrier
         * @param {string} carrierId Carrier ID
         * @param {CarrierUpdate} carrierUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierV1CarriersCarrierIdPatch: function (carrierId, carrierUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCarrierV1CarriersCarrierIdPatch(carrierId, carrierUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierApi.updateCarrierV1CarriersCarrierIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CarrierApiFp = CarrierApiFp;
/**
 * CarrierApi - factory interface
 * @export
 */
var CarrierApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierApiFp)(configuration);
    return {
        /**
         * # Translate Mothership carrier ID to CPS ID  Returns only CPS/SF/MS ID of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Mothership Id To Cps Id
         * @param {number} mothershipId Mothership ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet: function (mothershipId, options) {
            return localVarFp.mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet(mothershipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Read Carrier  Returns core information associated with the Carrier.  ---  ## Permissions  `view_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/read_carrier_v1_carriers__carrier_id__get\">here</a> may be returned.
         * @summary Read Carrier
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCarrierV1CarriersCarrierIdGet: function (carrierId, options) {
            return localVarFp.readCarrierV1CarriersCarrierIdGet(carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Translate Salesforce carrier ID to CPS ID  Returns only CPS/MS/SF IDs of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
         * @summary Salesforce Id To Cps Id
         * @param {string} salesforceId Salesforce ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet: function (salesforceId, options) {
            return localVarFp.salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet(salesforceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Update Carrier  Updates core information associated with the Carrier.  ---  ## Permissions  `update_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/update_carrier_v1_carriers__carrier_id__patch\">here</a> may be returned.
         * @summary Update Carrier
         * @param {string} carrierId Carrier ID
         * @param {CarrierUpdate} carrierUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierV1CarriersCarrierIdPatch: function (carrierId, carrierUpdate, options) {
            return localVarFp.updateCarrierV1CarriersCarrierIdPatch(carrierId, carrierUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierApiFactory = CarrierApiFactory;
/**
 * CarrierApi - object-oriented interface
 * @export
 * @class CarrierApi
 * @extends {BaseAPI}
 */
var CarrierApi = /** @class */ (function (_super) {
    __extends(CarrierApi, _super);
    function CarrierApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * # Translate Mothership carrier ID to CPS ID  Returns only CPS/SF/MS ID of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
     * @summary Mothership Id To Cps Id
     * @param {number} mothershipId Mothership ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    CarrierApi.prototype.mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet = function (mothershipId, options) {
        var _this = this;
        return (0, exports.CarrierApiFp)(this.configuration).mothershipIdToCpsIdV1CarriersIdFromMothershipMothershipIdGet(mothershipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Read Carrier  Returns core information associated with the Carrier.  ---  ## Permissions  `view_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/read_carrier_v1_carriers__carrier_id__get\">here</a> may be returned.
     * @summary Read Carrier
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    CarrierApi.prototype.readCarrierV1CarriersCarrierIdGet = function (carrierId, options) {
        var _this = this;
        return (0, exports.CarrierApiFp)(this.configuration).readCarrierV1CarriersCarrierIdGet(carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Translate Salesforce carrier ID to CPS ID  Returns only CPS/MS/SF IDs of the carrier.  ---  ## Permissions  There are no required permissions for this endpoint.  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/\">here</a> may be returned.
     * @summary Salesforce Id To Cps Id
     * @param {string} salesforceId Salesforce ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    CarrierApi.prototype.salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet = function (salesforceId, options) {
        var _this = this;
        return (0, exports.CarrierApiFp)(this.configuration).salesforceIdToCpsIdV1CarriersIdFromSalesforceSalesforceIdGet(salesforceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Update Carrier  Updates core information associated with the Carrier.  ---  ## Permissions  `update_carrier`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Carriers/update_carrier_v1_carriers__carrier_id__patch\">here</a> may be returned.
     * @summary Update Carrier
     * @param {string} carrierId Carrier ID
     * @param {CarrierUpdate} carrierUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierApi
     */
    CarrierApi.prototype.updateCarrierV1CarriersCarrierIdPatch = function (carrierId, carrierUpdate, options) {
        var _this = this;
        return (0, exports.CarrierApiFp)(this.configuration).updateCarrierV1CarriersCarrierIdPatch(carrierId, carrierUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierApi;
}(base_1.BaseAPI));
exports.CarrierApi = CarrierApi;
/**
 * ContactsApi - axios parameter creator
 * @export
 */
var ContactsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * # Create a new Contact  Adds a new Contact to the associated Carrier.  ---  ## Permissions  `create_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/create_contact_v1_contacts_post\">here</a> may be returned.
         * @summary Create Contact
         * @param {string} carrierId Carrier ID
         * @param {ContactCreate} contactCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactV1CarriersCarrierIdContactsPost: function (carrierId, contactCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('createContactV1CarriersCarrierIdContactsPost', 'carrierId', carrierId);
                            // verify required parameter 'contactCreate' is not null or undefined
                            (0, common_1.assertParamExists)('createContactV1CarriersCarrierIdContactsPost', 'contactCreate', contactCreate);
                            localVarPath = "/v1/carriers/{carrier_id}/contacts"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Delete a Contact  Deletes a Contact (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/delete_contact_v1_contacts__contact_id__delete\">here</a> may be returned.
         * @summary Delete Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactV1CarriersCarrierIdContactsContactIdDelete: function (contactId, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteContactV1CarriersCarrierIdContactsContactIdDelete', 'contactId', contactId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteContactV1CarriersCarrierIdContactsContactIdDelete', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/contacts/{contact_id}"
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Get a list of Contacts  Returns a list of Contacts associated to the carrier.  ---  ## Permissions  `view_contact_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/list_contacts_v1_contacts_get\">here</a> may be returned.
         * @summary List Carrier Contacts
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {boolean} [isPrimary] Set to get only primary/non-primary contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierContactsV1CarriersCarrierIdContactsGet: function (carrierId, showDeleted, isPrimary, offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('listCarrierContactsV1CarriersCarrierIdContactsGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/contacts"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (isPrimary !== undefined) {
                                localVarQueryParameter['is_primary'] = isPrimary;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Read a Contact  Returns a single Contact object by ID.  ---  ## Permissions  `view_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/read_contact_v1_contacts__contact_id__get\">here</a> may be returned.
         * @summary Read Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readContactV1CarriersCarrierIdContactsContactIdGet: function (contactId, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('readContactV1CarriersCarrierIdContactsContactIdGet', 'contactId', contactId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('readContactV1CarriersCarrierIdContactsContactIdGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/contacts/{contact_id}"
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Update a Contact  Updates a contact associated with the Carrier.  ---  ## Permissions  `update_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/update_contact_v1_contacts__contact_id__patch\">here</a> may be returned.
         * @summary Update Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {ContactUpdate} contactUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactV1CarriersCarrierIdContactsContactIdPatch: function (contactId, carrierId, contactUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('updateContactV1CarriersCarrierIdContactsContactIdPatch', 'contactId', contactId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('updateContactV1CarriersCarrierIdContactsContactIdPatch', 'carrierId', carrierId);
                            // verify required parameter 'contactUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateContactV1CarriersCarrierIdContactsContactIdPatch', 'contactUpdate', contactUpdate);
                            localVarPath = "/v1/carriers/{carrier_id}/contacts/{contact_id}"
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contactUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ContactsApiAxiosParamCreator = ContactsApiAxiosParamCreator;
/**
 * ContactsApi - functional programming interface
 * @export
 */
var ContactsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContactsApiAxiosParamCreator)(configuration);
    return {
        /**
         * # Create a new Contact  Adds a new Contact to the associated Carrier.  ---  ## Permissions  `create_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/create_contact_v1_contacts_post\">here</a> may be returned.
         * @summary Create Contact
         * @param {string} carrierId Carrier ID
         * @param {ContactCreate} contactCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactV1CarriersCarrierIdContactsPost: function (carrierId, contactCreate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createContactV1CarriersCarrierIdContactsPost(carrierId, contactCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.createContactV1CarriersCarrierIdContactsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Delete a Contact  Deletes a Contact (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/delete_contact_v1_contacts__contact_id__delete\">here</a> may be returned.
         * @summary Delete Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactV1CarriersCarrierIdContactsContactIdDelete: function (contactId, carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteContactV1CarriersCarrierIdContactsContactIdDelete(contactId, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.deleteContactV1CarriersCarrierIdContactsContactIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Get a list of Contacts  Returns a list of Contacts associated to the carrier.  ---  ## Permissions  `view_contact_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/list_contacts_v1_contacts_get\">here</a> may be returned.
         * @summary List Carrier Contacts
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {boolean} [isPrimary] Set to get only primary/non-primary contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierContactsV1CarriersCarrierIdContactsGet: function (carrierId, showDeleted, isPrimary, offset, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listCarrierContactsV1CarriersCarrierIdContactsGet(carrierId, showDeleted, isPrimary, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.listCarrierContactsV1CarriersCarrierIdContactsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Read a Contact  Returns a single Contact object by ID.  ---  ## Permissions  `view_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/read_contact_v1_contacts__contact_id__get\">here</a> may be returned.
         * @summary Read Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readContactV1CarriersCarrierIdContactsContactIdGet: function (contactId, carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readContactV1CarriersCarrierIdContactsContactIdGet(contactId, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.readContactV1CarriersCarrierIdContactsContactIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Update a Contact  Updates a contact associated with the Carrier.  ---  ## Permissions  `update_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/update_contact_v1_contacts__contact_id__patch\">here</a> may be returned.
         * @summary Update Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {ContactUpdate} contactUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactV1CarriersCarrierIdContactsContactIdPatch: function (contactId, carrierId, contactUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateContactV1CarriersCarrierIdContactsContactIdPatch(contactId, carrierId, contactUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.updateContactV1CarriersCarrierIdContactsContactIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContactsApiFp = ContactsApiFp;
/**
 * ContactsApi - factory interface
 * @export
 */
var ContactsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContactsApiFp)(configuration);
    return {
        /**
         * # Create a new Contact  Adds a new Contact to the associated Carrier.  ---  ## Permissions  `create_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/create_contact_v1_contacts_post\">here</a> may be returned.
         * @summary Create Contact
         * @param {string} carrierId Carrier ID
         * @param {ContactCreate} contactCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactV1CarriersCarrierIdContactsPost: function (carrierId, contactCreate, options) {
            return localVarFp.createContactV1CarriersCarrierIdContactsPost(carrierId, contactCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Delete a Contact  Deletes a Contact (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/delete_contact_v1_contacts__contact_id__delete\">here</a> may be returned.
         * @summary Delete Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContactV1CarriersCarrierIdContactsContactIdDelete: function (contactId, carrierId, options) {
            return localVarFp.deleteContactV1CarriersCarrierIdContactsContactIdDelete(contactId, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Get a list of Contacts  Returns a list of Contacts associated to the carrier.  ---  ## Permissions  `view_contact_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/list_contacts_v1_contacts_get\">here</a> may be returned.
         * @summary List Carrier Contacts
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {boolean} [isPrimary] Set to get only primary/non-primary contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierContactsV1CarriersCarrierIdContactsGet: function (carrierId, showDeleted, isPrimary, offset, limit, options) {
            return localVarFp.listCarrierContactsV1CarriersCarrierIdContactsGet(carrierId, showDeleted, isPrimary, offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Read a Contact  Returns a single Contact object by ID.  ---  ## Permissions  `view_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/read_contact_v1_contacts__contact_id__get\">here</a> may be returned.
         * @summary Read Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readContactV1CarriersCarrierIdContactsContactIdGet: function (contactId, carrierId, options) {
            return localVarFp.readContactV1CarriersCarrierIdContactsContactIdGet(contactId, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Update a Contact  Updates a contact associated with the Carrier.  ---  ## Permissions  `update_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/update_contact_v1_contacts__contact_id__patch\">here</a> may be returned.
         * @summary Update Contact
         * @param {string} contactId
         * @param {string} carrierId Carrier ID
         * @param {ContactUpdate} contactUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContactV1CarriersCarrierIdContactsContactIdPatch: function (contactId, carrierId, contactUpdate, options) {
            return localVarFp.updateContactV1CarriersCarrierIdContactsContactIdPatch(contactId, carrierId, contactUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContactsApiFactory = ContactsApiFactory;
/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
var ContactsApi = /** @class */ (function (_super) {
    __extends(ContactsApi, _super);
    function ContactsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * # Create a new Contact  Adds a new Contact to the associated Carrier.  ---  ## Permissions  `create_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/create_contact_v1_contacts_post\">here</a> may be returned.
     * @summary Create Contact
     * @param {string} carrierId Carrier ID
     * @param {ContactCreate} contactCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.createContactV1CarriersCarrierIdContactsPost = function (carrierId, contactCreate, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).createContactV1CarriersCarrierIdContactsPost(carrierId, contactCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Delete a Contact  Deletes a Contact (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/delete_contact_v1_contacts__contact_id__delete\">here</a> may be returned.
     * @summary Delete Contact
     * @param {string} contactId
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.deleteContactV1CarriersCarrierIdContactsContactIdDelete = function (contactId, carrierId, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).deleteContactV1CarriersCarrierIdContactsContactIdDelete(contactId, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Get a list of Contacts  Returns a list of Contacts associated to the carrier.  ---  ## Permissions  `view_contact_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/list_contacts_v1_contacts_get\">here</a> may be returned.
     * @summary List Carrier Contacts
     * @param {string} carrierId Carrier ID
     * @param {boolean} [showDeleted] Set to show deleted contacts
     * @param {boolean} [isPrimary] Set to get only primary/non-primary contacts
     * @param {number} [offset] Query result offset
     * @param {number} [limit] Query result limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.listCarrierContactsV1CarriersCarrierIdContactsGet = function (carrierId, showDeleted, isPrimary, offset, limit, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).listCarrierContactsV1CarriersCarrierIdContactsGet(carrierId, showDeleted, isPrimary, offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Read a Contact  Returns a single Contact object by ID.  ---  ## Permissions  `view_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/read_contact_v1_contacts__contact_id__get\">here</a> may be returned.
     * @summary Read Contact
     * @param {string} contactId
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.readContactV1CarriersCarrierIdContactsContactIdGet = function (contactId, carrierId, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).readContactV1CarriersCarrierIdContactsContactIdGet(contactId, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Update a Contact  Updates a contact associated with the Carrier.  ---  ## Permissions  `update_contact`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Contacts/update_contact_v1_contacts__contact_id__patch\">here</a> may be returned.
     * @summary Update Contact
     * @param {string} contactId
     * @param {string} carrierId Carrier ID
     * @param {ContactUpdate} contactUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.updateContactV1CarriersCarrierIdContactsContactIdPatch = function (contactId, carrierId, contactUpdate, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).updateContactV1CarriersCarrierIdContactsContactIdPatch(contactId, carrierId, contactUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContactsApi;
}(base_1.BaseAPI));
exports.ContactsApi = ContactsApi;
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
var DocumentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * # Delete a Document  Deletes a Document (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/delete_document_v1_documents__document_id__delete\">here</a> may be returned.
         * @summary Delete Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete: function (documentId, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Get Document download URL  Get a temporary URL for downloading a Document\'s associated file.  ---  ## Permissions  `download_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/get_document_download_url_v1_documents__document_id__download_url_get\">here</a> may be returned.
         * @summary Get Document Download Url
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet: function (documentId, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet', 'documentId', documentId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/documents/{document_id}/download-url"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Get a list of a carrier\'s Documents  Returns a list of Documents associated with the carrier.  ---  ## Permissions  `view_document_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/list_documents_v1_documents_get\">here</a> may be returned.
         * @summary List Carrier Documents
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierDocumentsV1CarriersCarrierIdDocumentsGet: function (carrierId, showDeleted, offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('listCarrierDocumentsV1CarriersCarrierIdDocumentsGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/documents"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Read a Document  Returns a single Document object by ID.  ---  ## Permissions  `view_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/read_document_v1_documents__document_id__get\">here</a> may be returned.
         * @summary Read Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet: function (documentId, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet', 'documentId', documentId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet', 'carrierId', carrierId);
                            localVarPath = "/v1/carriers/{carrier_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Update a Document  Updates a document associated with the Carrier.  ---  ## Permissions  `update_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/update_document_v1_documents__document_id__patch\">here</a> may be returned.
         * @summary Update Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch: function (documentId, carrierId, documentUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch', 'documentId', documentId);
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch', 'carrierId', carrierId);
                            // verify required parameter 'documentUpdate' is not null or undefined
                            (0, common_1.assertParamExists)('updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch', 'documentUpdate', documentUpdate);
                            localVarPath = "/v1/carriers/{carrier_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * # Create a new Document  Adds a new Document to the associated Carrier. The update end-point would then be used to adjust any meta-data associated with the document.  The following file-types are currently supported: `JPG`, `PNG`, `PDF`. File-types are checked for the correct binary headers (as opposed to just checking file extensions).  Uploaded documents may not exceed 10MB in size.  ---  ## Permissions  `upload_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/upload_document_v1_documents_post\">here</a> may be returned.
         * @summary Upload Document
         * @param {string} carrierId Carrier ID
         * @param {File} file
         * @param {DocumentType} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentV1CarriersCarrierIdDocumentsPost: function (carrierId, file, documentType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDocumentV1CarriersCarrierIdDocumentsPost', 'carrierId', carrierId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDocumentV1CarriersCarrierIdDocumentsPost', 'file', file);
                            // verify required parameter 'documentType' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDocumentV1CarriersCarrierIdDocumentsPost', 'documentType', documentType);
                            localVarPath = "/v1/carriers/{carrier_id}/documents"
                                .replace("{".concat("carrier_id", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (documentType !== undefined) {
                                localVarFormParams.append('document_type', documentType);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiAxiosParamCreator = DocumentsApiAxiosParamCreator;
/**
 * DocumentsApi - functional programming interface
 * @export
 */
var DocumentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * # Delete a Document  Deletes a Document (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/delete_document_v1_documents__document_id__delete\">here</a> may be returned.
         * @summary Delete Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete: function (documentId, carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete(documentId, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Get Document download URL  Get a temporary URL for downloading a Document\'s associated file.  ---  ## Permissions  `download_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/get_document_download_url_v1_documents__document_id__download_url_get\">here</a> may be returned.
         * @summary Get Document Download Url
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet: function (documentId, carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet(documentId, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Get a list of a carrier\'s Documents  Returns a list of Documents associated with the carrier.  ---  ## Permissions  `view_document_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/list_documents_v1_documents_get\">here</a> may be returned.
         * @summary List Carrier Documents
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierDocumentsV1CarriersCarrierIdDocumentsGet: function (carrierId, showDeleted, offset, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listCarrierDocumentsV1CarriersCarrierIdDocumentsGet(carrierId, showDeleted, offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.listCarrierDocumentsV1CarriersCarrierIdDocumentsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Read a Document  Returns a single Document object by ID.  ---  ## Permissions  `view_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/read_document_v1_documents__document_id__get\">here</a> may be returned.
         * @summary Read Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet: function (documentId, carrierId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet(documentId, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Update a Document  Updates a document associated with the Carrier.  ---  ## Permissions  `update_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/update_document_v1_documents__document_id__patch\">here</a> may be returned.
         * @summary Update Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch: function (documentId, carrierId, documentUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch(documentId, carrierId, documentUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * # Create a new Document  Adds a new Document to the associated Carrier. The update end-point would then be used to adjust any meta-data associated with the document.  The following file-types are currently supported: `JPG`, `PNG`, `PDF`. File-types are checked for the correct binary headers (as opposed to just checking file extensions).  Uploaded documents may not exceed 10MB in size.  ---  ## Permissions  `upload_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/upload_document_v1_documents_post\">here</a> may be returned.
         * @summary Upload Document
         * @param {string} carrierId Carrier ID
         * @param {File} file
         * @param {DocumentType} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentV1CarriersCarrierIdDocumentsPost: function (carrierId, file, documentType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadDocumentV1CarriersCarrierIdDocumentsPost(carrierId, file, documentType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.uploadDocumentV1CarriersCarrierIdDocumentsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiFp = DocumentsApiFp;
/**
 * DocumentsApi - factory interface
 * @export
 */
var DocumentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentsApiFp)(configuration);
    return {
        /**
         * # Delete a Document  Deletes a Document (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/delete_document_v1_documents__document_id__delete\">here</a> may be returned.
         * @summary Delete Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete: function (documentId, carrierId, options) {
            return localVarFp.deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete(documentId, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Get Document download URL  Get a temporary URL for downloading a Document\'s associated file.  ---  ## Permissions  `download_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/get_document_download_url_v1_documents__document_id__download_url_get\">here</a> may be returned.
         * @summary Get Document Download Url
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet: function (documentId, carrierId, options) {
            return localVarFp.getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet(documentId, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Get a list of a carrier\'s Documents  Returns a list of Documents associated with the carrier.  ---  ## Permissions  `view_document_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/list_documents_v1_documents_get\">here</a> may be returned.
         * @summary List Carrier Documents
         * @param {string} carrierId Carrier ID
         * @param {boolean} [showDeleted] Set to show deleted contacts
         * @param {number} [offset] Query result offset
         * @param {number} [limit] Query result limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierDocumentsV1CarriersCarrierIdDocumentsGet: function (carrierId, showDeleted, offset, limit, options) {
            return localVarFp.listCarrierDocumentsV1CarriersCarrierIdDocumentsGet(carrierId, showDeleted, offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Read a Document  Returns a single Document object by ID.  ---  ## Permissions  `view_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/read_document_v1_documents__document_id__get\">here</a> may be returned.
         * @summary Read Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet: function (documentId, carrierId, options) {
            return localVarFp.readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet(documentId, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Update a Document  Updates a document associated with the Carrier.  ---  ## Permissions  `update_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/update_document_v1_documents__document_id__patch\">here</a> may be returned.
         * @summary Update Document
         * @param {string} documentId
         * @param {string} carrierId Carrier ID
         * @param {DocumentUpdate} documentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch: function (documentId, carrierId, documentUpdate, options) {
            return localVarFp.updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch(documentId, carrierId, documentUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * # Create a new Document  Adds a new Document to the associated Carrier. The update end-point would then be used to adjust any meta-data associated with the document.  The following file-types are currently supported: `JPG`, `PNG`, `PDF`. File-types are checked for the correct binary headers (as opposed to just checking file extensions).  Uploaded documents may not exceed 10MB in size.  ---  ## Permissions  `upload_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/upload_document_v1_documents_post\">here</a> may be returned.
         * @summary Upload Document
         * @param {string} carrierId Carrier ID
         * @param {File} file
         * @param {DocumentType} documentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentV1CarriersCarrierIdDocumentsPost: function (carrierId, file, documentType, options) {
            return localVarFp.uploadDocumentV1CarriersCarrierIdDocumentsPost(carrierId, file, documentType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentsApiFactory = DocumentsApiFactory;
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * # Delete a Document  Deletes a Document (soft-delete) associated with the Carrier.  ---  ## Permissions  `delete_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/delete_document_v1_documents__document_id__delete\">here</a> may be returned.
     * @summary Delete Document
     * @param {string} documentId
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete = function (documentId, carrierId, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).deleteDocumentV1CarriersCarrierIdDocumentsDocumentIdDelete(documentId, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Get Document download URL  Get a temporary URL for downloading a Document\'s associated file.  ---  ## Permissions  `download_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/get_document_download_url_v1_documents__document_id__download_url_get\">here</a> may be returned.
     * @summary Get Document Download Url
     * @param {string} documentId
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet = function (documentId, carrierId, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).getDocumentDownloadUrlV1CarriersCarrierIdDocumentsDocumentIdDownloadUrlGet(documentId, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Get a list of a carrier\'s Documents  Returns a list of Documents associated with the carrier.  ---  ## Permissions  `view_document_list`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/list_documents_v1_documents_get\">here</a> may be returned.
     * @summary List Carrier Documents
     * @param {string} carrierId Carrier ID
     * @param {boolean} [showDeleted] Set to show deleted contacts
     * @param {number} [offset] Query result offset
     * @param {number} [limit] Query result limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.listCarrierDocumentsV1CarriersCarrierIdDocumentsGet = function (carrierId, showDeleted, offset, limit, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).listCarrierDocumentsV1CarriersCarrierIdDocumentsGet(carrierId, showDeleted, offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Read a Document  Returns a single Document object by ID.  ---  ## Permissions  `view_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/read_document_v1_documents__document_id__get\">here</a> may be returned.
     * @summary Read Document
     * @param {string} documentId
     * @param {string} carrierId Carrier ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet = function (documentId, carrierId, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).readDocumentV1CarriersCarrierIdDocumentsDocumentIdGet(documentId, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Update a Document  Updates a document associated with the Carrier.  ---  ## Permissions  `update_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/update_document_v1_documents__document_id__patch\">here</a> may be returned.
     * @summary Update Document
     * @param {string} documentId
     * @param {string} carrierId Carrier ID
     * @param {DocumentUpdate} documentUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch = function (documentId, carrierId, documentUpdate, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).updateDocumentV1CarriersCarrierIdDocumentsDocumentIdPatch(documentId, carrierId, documentUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * # Create a new Document  Adds a new Document to the associated Carrier. The update end-point would then be used to adjust any meta-data associated with the document.  The following file-types are currently supported: `JPG`, `PNG`, `PDF`. File-types are checked for the correct binary headers (as opposed to just checking file extensions).  Uploaded documents may not exceed 10MB in size.  ---  ## Permissions  `upload_document`  ---  ## Custom Errors  In addition to one of the Common Error Codes, one of the error codes found <a href=\"https://developers.sennder.tech/catalog/carriers-and-drivers/api/carrier-profile/definition#/Documents/upload_document_v1_documents_post\">here</a> may be returned.
     * @summary Upload Document
     * @param {string} carrierId Carrier ID
     * @param {File} file
     * @param {DocumentType} documentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.uploadDocumentV1CarriersCarrierIdDocumentsPost = function (carrierId, file, documentType, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).uploadDocumentV1CarriersCarrierIdDocumentsPost(carrierId, file, documentType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentsApi;
}(base_1.BaseAPI));
exports.DocumentsApi = DocumentsApi;
/**
 * HealthApi - axios parameter creator
 * @export
 */
var HealthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthInternalHealthGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/internal/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthApiAxiosParamCreator = HealthApiAxiosParamCreator;
/**
 * HealthApi - functional programming interface
 * @export
 */
var HealthApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthInternalHealthGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHealthInternalHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HealthApi.getHealthInternalHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.HealthApiFp = HealthApiFp;
/**
 * HealthApi - factory interface
 * @export
 */
var HealthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthInternalHealthGet: function (options) {
            return localVarFp.getHealthInternalHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthApiFactory = HealthApiFactory;
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
var HealthApi = /** @class */ (function (_super) {
    __extends(HealthApi, _super);
    function HealthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    HealthApi.prototype.getHealthInternalHealthGet = function (options) {
        var _this = this;
        return (0, exports.HealthApiFp)(this.configuration).getHealthInternalHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthApi;
}(base_1.BaseAPI));
exports.HealthApi = HealthApi;
